import React from 'react';
import Picky from 'react-picky';

import I18n from 'i18n-react';

class NumberOfStopsFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      originFilter: props.originFilter,
      filteredList: props.filteredList,
      numberOfStopsComplete: [
        {
          id: 0,
          name: I18n.translate('filters.numberOfStops.directFlight')
        },
        {
          id: 1,
          name: I18n.translate('filters.numberOfStops.oneStop')
        },
        {
          id: 2,
          name: I18n.translate('filters.numberOfStops.twoStopsOrMore')
        }
      ]
    };
    this.selectOption = this.selectOption.bind(this);
  }

  selectOption(value) {
    this.action(value);
  }

  action = value =>
    new Promise((resolve, reject) => {
      const numberOfStopsFiltered = this.state.filteredList ; 
      numberOfStopsFiltered.stopoverList = [] ;
      numberOfStopsFiltered.stopoverList.push(value)

      this.setState({ filteredList: numberOfStopsFiltered });
      this.props.updateFilters({filteredList: numberOfStopsFiltered}, this.props.flightType);
    });

  clearField() {
    const numberOfStopsFiltered = this.state.filteredList ;
    numberOfStopsFiltered.stopoverList = [] ;

    this.setState({ filteredList: numberOfStopsFiltered });
    this.props.updateFilters({filteredList: numberOfStopsFiltered}, this.props.flightType);
  }

  diferenceItem(completList, filteredList){
    const completListName = completList.map(x => {
      return x.name;
    })
    const filteredListName = filteredList.map(x => {
      return x.name;
    })

    const diferentItem = completListName.filter(x => {
      if (!filteredListName.includes(x)) {
        return true;
      }
    });
    return diferentItem;
  }

  render() {
    const { originFilter, filteredList, numberOfStopsComplete } = this.state;
    return (
      <div className="filter-wrapper">
        <Picky
          options={numberOfStopsComplete}
          value={filteredList.stopoverList}
          onChange={this.selectOption}
          open={false}
          valueKey="id"
          labelKey="name"
          placeholder={I18n.translate('filters.numberOfStops.withOrWithoutStopover')}
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          dropdownHeight={252}
          keepOpen={false}
          className={this.state.filteredList.stopoverList.length != 0 ? 'ta-dropdown selected' : 'ta-dropdown'}
          render={({
            style,
            isSelected,
            item,
            selectValue,
            labelKey,
            valueKey
          }) => {
            return (
              <li
                style={style}
                className={this.diferenceItem(numberOfStopsComplete, originFilter.stopoverList).includes(item[labelKey])?
                  'ta-radio button-invalid' :
                  isSelected ? 'ta-radio selected' : 'ta-radio'}
                key={item[valueKey]}
                onClick={() => selectValue(item)}
              >
                <input type="radio" checked={isSelected} readOnly />
                <span>{item[labelKey]}</span>
              </li>
              
            );
          }}
        />
        <div className="clear-btn" onClick={() => this.clearField()}><i className="icon-close"></i></div>
      </div>
    );
  }
}

export default NumberOfStopsFilter;


// WEBPACK FOOTER //
// ./src/components/flightSelection/filters/numberOfStopsFilter/NumberOfStopsFilter.jsx